import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">Description</div>
        <div className="descriptionbox-nav-box fade">Reviews(1025)</div>
      </div>
      <div className="descriptionbox-description">
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto odio odit, suscipit aut totam optio excepturi veniam tempora nisi, quidem dolores cum unde aliquam beatae numquam asperiores. In, obcaecati alias. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex reiciendis minima perferendis, ullam, magnam at itaque quidem beatae, architecto commodi sunt unde. Minus unde et, voluptate quod nam esse fuga.</p>
        <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit corrupti praesentium doloribus nostrum ea iure, adipisci vitae nulla perferendis. Consequuntur in ipsum ratione debitis eum molestiae libero? Cum, qui officiis?
        </p>
      </div>
    </div>
  )
}

export default DescriptionBox
